var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.25 8.25L21 12M21 12L17.25 15.75M21 12H3","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
